import { globalMixpanelReporter as _globalMixpanelReporter } from '@fiverr-private/identification_core';
import { MixpanelEventName, AdditionalPropsMap } from './mixpanel.types';
import { MIXPANEL_EXTENDED_PROPERTIES_MAP, ExtendedMixpanelEventProperties } from './mixpanel.constants';

export const globalMixpanelReporter = _globalMixpanelReporter.extend<
    MixpanelEventName,
    ExtendedMixpanelEventProperties,
    AdditionalPropsMap
>({ mixPanelPropertiesMap: MIXPANEL_EXTENDED_PROPERTIES_MAP });

globalMixpanelReporter.enrichContext({ package: '@fiverr-private/identification_marketplace' }, { preserve: true });
